import React from 'react';
import ReactDOM from 'react-dom';
import { Overlay, Container } from './styles';

export default function Modal({ imgSrc, setExpandImg }) {
  return ReactDOM.createPortal(
    <Overlay
      onClick={() => {
        setExpandImg(false);
      }}
    >
      <Container>
        <img
          loading='lazy'
          src={imgSrc}
          onClick={() => {
            setExpandImg(false);
          }}
        />

        <a download href={imgSrc} target='_blank' rel='noreferrer'>
          Download
        </a>
      </Container>
    </Overlay>,
    document.getElementById('modal-img-home')
  );
}
